import * as React from 'react';
import { Box, Chip, Menu, MenuItem } from '@mui/material';
import PreferencePill from './PreferencePill';
import { Preference } from '../../types/Preference';
import _, { Dictionary } from 'lodash';

type RolePillsCellProps = {
  rolesUuids: string[];
  prefByUuid: Dictionary<Preference>;
};

export function RolePillsCell({ rolesUuids, prefByUuid }: RolePillsCellProps) {
  const chips = _.compact(
    _.map(rolesUuids, (uuid) => {
      const preference = prefByUuid[uuid];
      return preference ? { value: preference.value, color: preference.color ?? null } : null;
    })
  );

  if (!chips.length) return null;

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleOpen = (e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const [first, ...rest] = chips;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
      <PreferencePill value={first.value} color={first.color} />
      {rest.length > 0 && (
        <>
          <Chip size="small" variant="outlined" label={`+${rest.length}`} onClick={handleOpen} sx={{ cursor: 'pointer' }} />
          <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
            {_.map(rest, ({ value, color }, index) => (
              <MenuItem key={`${value}-${index}`} disableGutters dense onClick={handleClose}>
                <Box sx={{ px: 1 }}>
                  <PreferencePill value={value} color={color} />
                </Box>
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </Box>
  );
}
